import React from 'react';

import LetterTile from './letter-tile.jsx';
import ButtonBack from './button-back.jsx';
import ContactBadges from './contact-badges.jsx';
import MenuContacts from './menu-contacts.jsx';
import { TOPIC_ME } from '../tinode/config'

import { sanitizeUrlForMime } from '../lib/utils.js';
import { Tinode } from '../tinode/tinode.js';

export default class SideNavbar extends React.PureComponent {
  render() {
    const icon_badges = [];
    if (this.props.trustedBadges) {
      this.props.trustedBadges.map((b) => {
        icon_badges.push({ icon: b, color: 'badge-inv' });
      });
    }
    let avatar = null;
    if (this.props.tinode) {
      avatar = this.props.tinode.authorizeURL(sanitizeUrlForMime(this.props.avatar, 'image'));
    }
    return (
      <div id="side-caption-panel" className="caption-panel">
        {this.props.onCancel ? <ButtonBack onBack={this.props.onCancel} /> : null}
        {avatar ?
          <div
            id="self-avatar"
            className="avatar-box"
            onClick={() => this.props.onShowDialog(Tinode.DIALOG_TYPE.PERSONAL_INFORMATION, { topicProfile: TOPIC_ME })}
          >
            <LetterTile
              tinode={this.props.tinode}
              avatar={avatar}
              topic={this.props.myUserId}
              title={this.props.title} />
          </div>
          :
          null}
        <div id="sidepanel-title" className="panel-title">{this.props.title}<ContactBadges badges={icon_badges} /></div>
        {this.props.state === 'contacts' ?
          <MenuContacts
            tinode={this.props.tinode}
            onNewTopic={this.props.onNewTopic}
            onNewTopicGroup={this.props.onNewTopicGroup}
            onSettings={this.props.onSettings}
            onShowDialog={this.props.onShowDialog}
            onMarkReadAllMessage={this.props.onMarkReadAllMessage}
            handleShowGroupMembers={this.props.handleShowGroupMembers}
          /> :
          null}
      </div>
    );
  }
};
